import __ from "web/Layout/Translations";

import { Functionality } from "web/types/Employee";
import { ICategoryFunctionalityMenuItem } from "web/types/Menu";

import type { SubscriptionQuoteConfig } from "web/features/subscriptionQuote/subscriptionQuoteSlice";

import buildSubscriptionSubmenuData from "./buildSubscriptionMenuData";
import type { SubmenuItem } from "./types";

const handleCategoryFunctionalityWebview = ({
  menuItem,
  hasEnabledAnySubscriptions,
  subscriptionConfig,
  enableMobilePreview,
  enableNewSubscriptionUI,
}: {
  menuItem: ICategoryFunctionalityMenuItem;
  hasEnabledAnySubscriptions: boolean;
  subscriptionConfig: SubscriptionQuoteConfig;
  enableMobilePreview: boolean;
  enableNewSubscriptionUI: boolean;
}): { title: string; submenu: SubmenuItem[] } | null => {
  if (
    menuItem.category_functionality === Functionality.SUBSCRIPTIONS &&
    hasEnabledAnySubscriptions &&
    (enableMobilePreview || enableNewSubscriptionUI)
  ) {
    return {
      title: __(menuItem.title),
      submenu: buildSubscriptionSubmenuData(
        subscriptionConfig,
        enableNewSubscriptionUI
      ),
    };
  }

  return null;
};

export default handleCategoryFunctionalityWebview;
